import * as t from '../types';
import {GET_TUTOR_ONE_2_ONE_REQUEST} from "../types";

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function groupSessionTutorReducer(state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case t.GET_GROUP_SESSION_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.GET_GROUP_SESSION_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload.data
            };
        case t.GET_GROUP_SESSION_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
